module.exports = __webpack_public_path__ + "static/media/logo.04907f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/06-assets/images/home/logo.png
// module id = 260
// module chunks = 0